import { toWords } from "number-to-words";

class ConfirmPrice {
  constructor() {
    this.items = null; // default
    this.init();
  }

  async init() {
    const getAgeLoading = (age) => {
      if (age <= 65) return { rate: 0, label: "No loading", note: "" };
      if (age <= 75)
        return {
          rate: 0.5,
          label: "+50%",
          note: "Health declaration required",
        };
      if (age <= 80)
        return {
          rate: 0.75,
          label: "+75%",
          note: "Health declaration required",
        };
      if (age <= 85)
        return {
          rate: 1.0,
          label: "+100%",
          note: "Health declaration + SIMA preapproval",
        };
      if (age <= 90)
        return {
          rate: 2.0,
          label: "+200%",
          note: "Health declaration + SIMA preapproval",
        };
      return null;
    };
    const RATES = {
      0: {
        // Elite
        0: [
          // Individual
          [20.7, 17.4, 14.7],
          [23.8, 20.2, 17.2],
          [29.7, 25.3, 21.6],
          [34.2, 29.2, 24.9],
          [42.0, 35.8, 30.3],
          [65.3, 55.6, 47.3],
          [75.4, 64.0, 54.5],
          [90.3, 76.6, 65.2],
          [105.2, 89.3, 76.0],
          [132.7, 112.8, 95.8],
          [146.3, 124.4, 105.7],
          [160.1, 136.2, 115.7],
          [240.2, 204.5, 173.7],
          [320.2, 272.3, 231.3],
          [412.5, 352.0, 297.0],
        ],
        1: [
          // Family
          [39.4, 29.7, 23.8],
          [45.1, 34.5, 27.6],
          [56.3, 43.0, 34.5],
          [65.0, 49.6, 39.7],
          [79.9, 60.7, 48.4],
          [124.2, 88.8, 75.7],
          [143.1, 108.9, 84.5],
          [171.6, 130.5, 103.1],
          [199.9, 151.9, 121.7],
          [252.0, 191.6, 153.3],
          [278.1, 211.5, 169.2],
          [304.2, 231.4, 185.0],
          [456.2, 347.3, 277.5],
          [608.4, 463.0, 370.0],
          [775.5, 666.6, 562.1],
        ],
      },
      1: {
        // Platinum
        0: [
          [18.8, 15.8, 13.4],
          [21.6, 18.4, 15.6],
          [27.0, 23.0, 19.6],
          [31.1, 26.5, 22.6],
          [38.2, 32.5, 27.5],
          [59.4, 50.5, 43.0],
          [68.5, 58.2, 49.5],
          [82.1, 69.6, 59.3],
          [95.6, 81.2, 69.1],
          [120.6, 102.5, 87.1],
          [133.0, 113.1, 96.1],
          [145.5, 123.8, 105.2],
          [218.4, 185.9, 157.9],
          [291.1, 247.5, 210.3],
          [374.0, 319.0, 269.5],
        ],
        1: [
          [35.8, 27.0, 21.6],
          [41.0, 31.4, 25.1],
          [51.2, 39.1, 31.4],
          [59.1, 45.1, 36.1],
          [72.6, 55.2, 44.0],
          [112.9, 80.7, 68.8],
          [130.1, 99.0, 76.8],
          [156.0, 118.6, 93.7],
          [181.7, 138.1, 110.6],
          [229.1, 174.2, 139.4],
          [253.0, 192.5, 154.0],
          [276.5, 210.4, 168.2],
          [414.7, 315.7, 252.3],
          [553.1, 420.9, 336.4],
          [705.0, 606.1, 511.5],
        ],
      },
      2: {
        // Gold
        0: [
          [9.1, 7.7, 6.5],
          [11.4, 9.7, 8.4],
          [13.9, 11.9, 10.1],
          [16.8, 14.3, 12.3],
          [22.3, 19.0, 16.1],
          [28.2, 24.0, 20.4],
          [40.8, 34.7, 29.5],
          [50.5, 43.0, 36.5],
          [60.2, 51.3, 43.6],
          [61.3, 52.1, 44.3],
          [61.8, 52.6, 44.7],
          [62.4, 53.0, 45.1],
          [93.5, 79.6, 67.7],
          [124.7, 106.0, 90.2],
          [261.8, 223.3, 188.7],
        ],
        1: [
          [17.3, 13.1, 10.8],
          [21.8, 16.5, 12.4],
          [26.3, 20.2, 15.2],
          [32.0, 24.2, 19.7],
          [42.5, 32.3, 23.2],
          [53.5, 40.7, 34.7],
          [73.4, 59.0, 51.6],
          [81.8, 73.2, 58.5],
          [90.3, 87.2, 65.3],
          [101.3, 88.7, 67.7],
          [106.8, 89.4, 68.8],
          [112.3, 90.2, 70.0],
          [168.5, 135.3, 104.9],
          [224.6, 180.4, 139.9],
          [497.4, 424.3, 363.0],
        ],
      },
      3: {
        // Silver
        0: [
          [5.9, 5.3, 4.2],
          [7.4, 6.5, 5.4],
          [9.1, 8.1, 6.5],
          [10.9, 9.8, 7.9],
          [13.6, 12.1, 9.9],
          [18.4, 16.5, 13.3],
          [23.8, 21.3, 17.3],
          [28.1, 25.1, 20.4],
          [32.2, 28.8, 23.3],
          [41.1, 36.9, 29.7],
          [45.5, 40.8, 32.9],
          [49.9, 44.8, 36.1],
          [74.9, 67.1, 54.1],
          [99.9, 89.5, 72.2],
          [187.0, 160.8, 137.5],
        ],
        1: [
          [11.3, 8.9, 6.6],
          [14.0, 10.7, 8.6],
          [17.3, 12.2, 10.5],
          [20.7, 16.2, 12.7],
          [26.0, 20.6, 15.8],
          [35.0, 28.1, 21.2],
          [45.1, 36.2, 26.6],
          [53.2, 42.7, 32.0],
          [61.3, 49.1, 37.4],
          [78.1, 62.6, 47.5],
          [86.5, 69.3, 52.6],
          [94.8, 76.0, 57.6],
          [143.0, 114.1, 86.5],
          [189.6, 152.0, 115.3],
          [358.2, 305.5, 260.7],
        ],
      },
      4: {
        // Standard
        0: [
          [3.0, 2.8, 2.2],
          [3.5, 3.2, 2.5],
          [4.2, 3.7, 3.0],
          [6.4, 5.8, 4.5],
          [7.2, 6.3, 5.2],
          [12.9, 11.6, 9.4],
          [16.8, 15.1, 12.1],
          [22.6, 20.2, 16.3],
          [28.2, 25.3, 20.4],
          [33.2, 29.8, 24.0],
          [35.6, 32.0, 25.7],
          [38.2, 34.3, 27.5],
          [57.3, 51.5, 41.3],
          [76.3, 68.6, 55.0],
          [150.8, 128.6, 108.7],
        ],
        1: [
          [5.6, 4.4, 3.5],
          [6.8, 4.7, 4.1],
          [7.9, 5.3, 4.7],
          [12.0, 7.4, 6.6],
          [13.5, 8.8, 7.9],
          [24.4, 16.1, 14.9],
          [32.0, 27.1, 19.4],
          [42.8, 35.1, 26.1],
          [53.5, 43.0, 32.7],
          [63.0, 49.0, 38.4],
          [68.2, 51.9, 41.1],
          [72.6, 54.9, 44.0],
          [108.9, 82.5, 66.0],
          [145.2, 109.8, 88.0],
          [286.6, 244.4, 206.5],
        ],
      },
    };

    const traveldetails = sessionStorage.getItem("travel_information");
    const parsed = JSON.parse(traveldetails);

    const data = Object.fromEntries(
      parsed.map((item) => [item.key, item.value]),
    );
    console.log("travel details =====>", data);

    const plan = data.type;
    const covtype = data.coverageType;
    const zone = data.zone;
    const ageNum = Number(data.age);
    const info = getAgeLoading(ageNum);
    const base = RATES[plan][covtype][data.duration][zone];
    const final = base * (1 + info.rate);

    const res = await fetch("https://open.er-api.com/v6/latest/USD");
    const json = await res.json();
    const pkrRate = json?.rates?.PKR || 0;

    const finalPKR = final * pkrRate;
    let deductible = "USD 100";
    if (ageNum > 85) deductible = "USD 300";
    else if (ageNum > 70) deductible = "USD 150";
    const deductibleUsd = ageNum > 85 ? 300 : ageNum > 70 ? 150 : 100;
    const result = {
      base,
      loading: info,
      final: parseFloat(final.toFixed(2)),
      finalPKR,
      deductible,
      deductibleUsd,
      pkrRate,
    };
    console.log(pkrRate);
    this.items = {
      id: 30001,
      name: "Confirm Price",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: [
        {
          id: 1,
          text: "PREMIUM ",
          name: "FINAL PREMIUM",
          price: final,
          result,
          type: "confirmpayment",
          // isfree: true,
          desc: "<p>Unlock the ultimate convenience with unlimited audio and video advice, giving you direct access to vet expert care &ndash; tailored to fit your busy lifestyle!</p>",
        },
      ],

      backtostart: false,
      text: [
        `Based on the information provided, the premium is Rs.  (Rupees  Only).`,
      ],
    };
  }

  async getAllItems() {
    if (!this.items) {
      await this.init();
    }
    return this.items;
  }
}

export default ConfirmPrice;
